// extracted by mini-css-extract-plugin
export var compactFilters = "_h8-4";
export var detailImage = "_h8-1";
export var dropdownContainer = "_h8-2";
export var imageContainer = "_h8-0";
export var selectedCard = "_h8-3";